export const isString = (str: unknown): str is string =>
  typeof str === 'string';

export const capitalize = <T = unknown>(str: T) =>
  isString(str)
    ? `${str[0].toUpperCase()}${str.substring(1).toLowerCase()}`
    : str;

export const toTitleCase = <T = unknown>(str: T) =>
  isString(str) ? str.replace(/[^\-'_\s]+/g, capitalize) : str;

export const toSafeLowerCase = <T = unknown>(str: T) =>
  isString(str) ? str.toLowerCase() : str;

export const safeTrim = <T = unknown>(str: T) =>
  isString(str) ? str.trim() : str;

export const safeSubstr = <T = unknown>(str: T, start: number, end: number) =>
  isString(str) ? str.substring(start, end) : str;
